import React from 'react';

const LogoThomsonReuters = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#1E293B"/>
    <path d="M16 16L24 12L32 16V36L24 32L16 36V16Z" fill="white"/>
    <circle cx="24" cy="22" r="3" fill="#1E293B"/>
    <circle cx="24" cy="30" r="2" fill="#1E293B"/>
  </svg>
);

export default LogoThomsonReuters;
